function arrowScrollToTop() {
  const scrollToTopButton = document.querySelector('.arrow-scroll-to-top');
  const scrollThreshold = 300; // Distance from the top of the page to show the button

  // Show or hide the button based on scroll position
  function toggleButtonVisibility() {
    if (document.body.scrollTop > scrollThreshold || document.documentElement.scrollTop > scrollThreshold) {
      scrollToTopButton.style.display = 'block';
    } else {
      scrollToTopButton.style.display = 'none';
    }
  }

  // Scroll to the top of the page smoothly
  function scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  window.addEventListener('scroll', toggleButtonVisibility, { passive: true });
  scrollToTopButton.addEventListener('click', scrollToTop);

  // Initial check to set button visibility
  toggleButtonVisibility();
}

document.addEventListener('DOMContentLoaded', arrowScrollToTop);